import React from "react";

const ARGOCD_INSTANCES = [
  {
    environment: "Development",
    cluster: "aks-dev",
    url: "https://argocd.ot-services-dev.net",
    color: "emerald",
  },
  {
    environment: "Staging",
    cluster: "aks-staging",
    url: "https://argocd.ot-services-stg.net",
    color: "amber",
  },
  {
    environment: "Production — USA",
    cluster: "aks-prod-usa",
    url: "https://argocd.ot-services-prd-usa.net",
    color: "blue",
  },
  {
    environment: "Production — EUR",
    cluster: "aks-prod-eur",
    url: "https://argocd.ot-services-prd-eur.net",
    color: "purple",
  },
  {
    environment: "Production — CAN",
    cluster: "aks-prod-can",
    url: "https://argocd.ot-services-prd-can.net",
    color: "teal",
  },
];

const getColors = (color: string) => {
  switch (color) {
    case "emerald":
      return {
        bg: "bg-emerald-50",
        border: "border-emerald-100",
        hover: "hover:bg-emerald-100",
        badge: "bg-emerald-100 text-emerald-800",
        button: "border-emerald-300 text-emerald-700 hover:bg-emerald-100",
        icon: "text-emerald-700",
        iconBg: "bg-emerald-100",
      };
    case "amber":
      return {
        bg: "bg-amber-50",
        border: "border-amber-100",
        hover: "hover:bg-amber-100",
        badge: "bg-amber-100 text-amber-800",
        button: "border-amber-300 text-amber-700 hover:bg-amber-100",
        icon: "text-amber-700",
        iconBg: "bg-amber-100",
      };
    case "blue":
        return {
            bg: "bg-blue-50",
            border: "border-blue-100",
            hover: "hover:bg-blue-100",
            badge: "bg-blue-100 text-blue-800",
            button: "border-blue-300 text-blue-700 hover:bg-blue-100",
            icon: "text-blue-700",
            iconBg: "bg-blue-100",
        };
    case "purple":
        return {
            bg: "bg-purple-50",
            border: "border-purple-100",
            hover: "hover:bg-purple-100",
            badge: "bg-purple-100 text-purple-800",
            button: "border-purple-300 text-purple-700 hover:bg-purple-100",
            icon: "text-purple-700",
            iconBg: "bg-purple-100",
        };
    case "teal":
    return {
        bg: "bg-teal-50",
        border: "border-teal-100",
        hover: "hover:bg-teal-100",
        badge: "bg-teal-100 text-teal-800",
        button: "border-teal-300 text-teal-700 hover:bg-teal-100",
        icon: "text-teal-700",
        iconBg: "bg-teal-100",
    };
    default:
      return {
        bg: "bg-gray-50",
        border: "border-gray-100",
        hover: "hover:bg-gray-100",
        badge: "bg-gray-100 text-gray-800",
        button: "border-gray-300 text-gray-700 hover:bg-gray-100",
        icon: "text-gray-700",
        iconBg: "bg-gray-100",
      };
  }
};

const ArgoCDPage: React.FC = () => {
  return (
    <div className="p-6">
      <div className="max-w-4xl mx-auto">
        <div className="overflow-hidden rounded-lg border border-indigo-100 shadow-lg bg-white">
          <div className="px-5 py-4 bg-gradient-to-r from-indigo-50 to-blue-50 border-b border-indigo-100">
            <h3 className="text-lg font-semibold text-gray-800">Kubernetes Deployments</h3>
            <p className="text-sm text-gray-500">View AKS deployment status and application health across environments</p>
          </div>

          <div className="p-5 grid grid-cols-1 sm:grid-cols-2 gap-4">
            {ARGOCD_INSTANCES.map((instance) => {
              const c = getColors(instance.color);
              return (
                <div
                  key={instance.environment}
                  className={`${c.bg} ${c.border} ${c.hover} border rounded-lg p-4 transition-colors duration-200`}
                >
                  <div className="flex items-start justify-between mb-3">
                    <div className="flex items-center gap-3">
                      <div className={`${c.iconBg} rounded-lg p-2 flex-shrink-0`}>
                        <svg xmlns="http://www.w3.org/2000/svg" className={`h-6 w-6 ${c.icon}`} fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 10l-8-4V7" />
                        </svg>
                      </div>
                      <div>
                        <h2 className="text-sm font-semibold text-gray-800">{instance.environment}</h2>
                        <p className="text-xs text-gray-500 font-mono">{instance.cluster}</p>
                      </div>
                    </div>
                  </div>

                  <a
                    href={instance.url}
                    target="_blank"
                    rel="noreferrer"
                    className={`inline-flex items-center px-3 py-1.5 border text-sm font-medium rounded-md bg-white transition-colors duration-150 ${c.button}`}
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1.5" viewBox="0 0 20 20" fill="currentColor">
                      <path d="M11 3a1 1 0 100 2h2.586l-6.293 6.293a1 1 0 101.414 1.414L15 6.414V9a1 1 0 102 0V4a1 1 0 00-1-1h-5z" />
                      <path d="M5 5a2 2 0 00-2 2v8a2 2 0 002 2h8a2 2 0 002-2v-3a1 1 0 10-2 0v3H5V7h3a1 1 0 000-2H5z" />
                    </svg>
                    Open ArgoCD
                  </a>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ArgoCDPage;